<template>
  <div class="text-center">
    <!--modal download-->
    <v-dialog v-model="dialog" hide-overlay :persistent="stato" width="275">
      <v-card light>
        <v-card-title style="text-align: center; display: block" :style="{ color: title == 'Attendere' ? 'black' : 'red' }">
          {{ title }}
          <v-btn circle x-small style="position: absolute; right: 5px; top: 5px; color: red" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text style="text-align: center">
          {{ message }}
          <v-progress-circular :rotate="360" :size="100" :width="15" :value="progress" color="blue">
            <b>{{ progress }}%</b>
          </v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { Base64 } from 'js-base64'

  export default {
    props: {
      idm: {
        type: String,
        required: false
      }
    },
    data: () => ({
      progress: 0,
      dialog: true,
      title: 'Attendere',
      message: 'Al termine del processo di caricamento, il PDF verrà aperto in una nuova finestra',
      stato: true
    }),
    computed: {
      ...mapState(['config'])
    },
    mounted() {
      this.download2()
    },
    watch: {
      dialog(newValue, oldValue) {
        this.$emit('trigger', newValue)
      }
    },
    methods: {
      async download() {
        let config = this.config
        let payload = {
          crmid: localStorage.LHinfo_volumi.split('-')[1].trim(),
          userid: localStorage.LHinfo_volumi.split('-')[0].trim(),
          codvol: this.$route.query.cod_vol
        }
        let filename = `${payload.codvol}_${payload.crmid}_${payload.userid.replace(/[^a-zA-Z ]/g, '')}`
        payload.filename = filename
        this.dialog = true
        //PUT
        this.$store.dispatch('putDownload', payload).then((res) => {
          if (res.status === 200) {
            let uri = `${config.pdf_build.url.test_file}/${config.pdf_build.source}/${filename}.json`
            //const uri = 'http://develop-dpp-static.10.39.73.160.nip.io/DPP_VOLUME_UNICO/024207774_0000000021_carlotta.uttinigiuffre.it.json' //test
            const body = {
              call: uri,
              type: 'GET'
            }
            let count = 0
            let countOk = 1
            let interval = setInterval(() => {
              this.$store
                .dispatch('API', body)
                .then((res) => {
                  if (res && res.data && parseInt(res.data.stato) < 2) {
                    /*let progress = Math.round(((res.data.parte || res.data.parti) / 16) * 100)
                    this.progress = progress > 100 ? 100 : progress*/
                    let progr = countOk * 5
                    this.progress = progr > 100 ? 100 : progr
                    countOk++
                  }
                  if (res && res.data && parseInt(res.data.stato) == 2) {
                    // stato 3 è errata
                    clearInterval(interval)

                    this.dialog = false
                    this.progress = 0
                    let windowReference = window.open()
                    windowReference.location = uri.replace('.json', '.pdf')
                  }
                  if (res && res.data && parseInt(res.data.stato) == 3) {
                    clearInterval(interval)

                    this.title = 'Errore nel servizio'
                    this.message = res.data.message
                    setTimeout(() => {
                      this.stato = false
                    }, 2000)
                  }
                })
                .catch((e) => {
                  count++
                  if (count > 15) {
                    clearInterval(interval)
                  }
                })
            }, 1000)
          } else {
            alert('errore nel servizio')
          }
        })
        //GET OGNI 5 SEC
      },
      async download2() {
        //BVA-171
        //https://api-lambda.lefebvregiuffre.it/v1/gfl-dpp-pdf-watermark
        try {
          let config = this.config
          let payload = {
            crmid: localStorage.LHinfo_volumi.split('-')[1].trim(),
            userid: localStorage.LHinfo_volumi.split('-')[0].trim(),
            codvol: this.$route.query.cod_vol
          }
          let watermarktext = 'Copyright Lefebvre Giuffrè - ' + payload.userid + ' - RIPRODUZIONE RISERVATA'
          let watermarktextBase64 = Base64.encode(watermarktext)
          let token = localStorage.token_biblio_vol_jwt
          let url = `https://api-lambda.lefebvregiuffre.it/v1/gfl-dpp-pdf-watermark`
          let headers = {
            Authorization: `Bearer ${token}`,
            Origin: window.location.origin
          }
          let body = {
            idDocMaster: this.idm,
            watermarkText: watermarktextBase64
          }
          this.dialog = true
          this.title = 'Attendere'
          this.message = 'Richiesta generazione PDF...'
          this.progress = 10
          const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(body)
          })
          const res = await response.json()
          console.log(res)
          if (res.success) {
            this.progress = 100
            this.dialog = false
            window.open(res.outputFile, '_blank')
          } else {
            this.title = 'Errore nel servizio'
            this.message = res && res.message ? res.message : 'Errore sconosciuto'
            this.progress = 0
            setTimeout(() => {
              this.stato = false
            }, 2000)
          }
        } catch (e) {
          this.title = 'Errore di rete'
          this.message = e.message || 'Errore sconosciuto'
          this.progress = 0
          setTimeout(() => {
            this.stato = false
          }, 2000)
        }
      }
    }
  }
</script>

<style>
  .v-progress-circular {
    margin: 1rem;
  }
  .centerall * {
    text-align: center !important;
  }
</style>
